import React, {FC, PropsWithChildren} from 'react';
import styled from 'styled-components';

import {defineMessage, Trans} from '../../../../../libs/shared/helpers/src/internationalization/react';
import {fontSizes, fontWeights} from '../../../../../libs/shared/ui/src/styles/fontStyles';
import {useLocalize} from '../../../../../srcCommon/internationalization/internationalizationContext';
import {useNoConversationsImageSrc} from '../../inboxesNoConversations';

/*
 * Props.
 */

interface SearchNoResultsHeaderProps {
  image?: string;
  imageWidth?: number;
  imageHeight?: number;
}

/*
 * Style.
 */

const StyledWrapperDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const StyledImg = styled.img<{$imageWidth?: number; $imageHeight?: number}>`
  width: ${(p) => p.$imageWidth ?? 200}px;
  height: ${(p) => p.$imageHeight ?? 200}px;
  margin-bottom: 20px;
`;

const StyledHeaderDiv = styled.div`
  color: ${(p) => p.theme.greys.shade90};
  font-size: ${fontSizes.large};
  font-weight: ${fontWeights.semibold};
  line-height: 20px;
  max-width: 480px;
  white-space: normal;
  text-align: center;
`;

/*
 * Component.
 */

export const SearchNoResultsHeader: FC<PropsWithChildren<SearchNoResultsHeaderProps>> = (props) => {
  const {image, imageWidth, imageHeight, children} = props;

  const inboxZeroImage = useNoConversationsImageSrc();

  const localize = useLocalize();

  return (
    <StyledWrapperDiv>
      <StyledImg
        $imageWidth={imageWidth}
        $imageHeight={imageHeight}
        src={image ?? inboxZeroImage}
        alt={localize(
          defineMessage({
            id: 'search-no-results-header',
            message: 'No results',
          }),
        )}
      />
      <StyledHeaderDiv>{children || <Trans id="search-no-results-header">No results</Trans>}</StyledHeaderDiv>
    </StyledWrapperDiv>
  );
};
